module.exports = __webpack_public_path__ + "static/media/reddit_icon.2c969cc8.png";